"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _tabItem = require("./tabItem.style");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  index: _propTypes.number,
  isActive: _propTypes.bool,
  onTabClick: _propTypes.func,
  children: _propTypes.node.isRequired
} : {};

const TabItem = ({
  index,
  isActive,
  onTabClick,
  children
}) => (0, _core.jsx)(_tabItem.Root, {
  id: `tabheader-${index}`,
  isActive: isActive,
  onClick: onTabClick
}, (0, _core.jsx)(_tabItem.Root.Label, {
  desktop: "md",
  mobile: "sm",
  component: "div"
}, children));

exports.TabItem = TabItem;
process.env.NODE_ENV !== "production" ? TabItem.propTypes = propTypes : void 0;
TabItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TabItem",
  "props": {
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "isActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onTabClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};